module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAeCAYAAAAy2w7YAAAAAXNSR0IArs4c6QAAASpJREFUSA1j+P//fygQPwfiE0AcwkArADT8JhAjgx1AjjLV7QMa+g/ZFij7O5CuBWJ2qlmIxRJkIZBvnaliGbKpeNhLgHLiFFmIx3B0qfdAgUwgZiLLQnTTiOCfAqoxItkyIgzGpuQPUHAiEPMRbSE2U0gQewpUG0aUZSQYik8p4byHTzeJcvjzHomGEaMce94jRieZapYC9cHzHiPIEKIikzxFr4Da3BkZGS/Q2iKQ8w4DLbIjL5eT4TtaWwQKujyQu2hp0TKg+Xqg+AFZxEBmisKnjebJG5Rh64AYe2WJz2kkyNG8CKJ5oUqXaoLmFR+oKs8CYvKyBJERjlJAgvMFqQQBi7DnCVItAakHWoSvAclGjplY9QAtArkaGRDOE1hNIiAItIEujXwAFKhJ5wNxOVMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/game-button/ic_play.png
// module id = 329
// module chunks = 0